// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1pyPj","file":"styles_file__2_ZDO"};